import { useContext, useEffect, useState } from "react";
import styles from "./Sapper.module.css"
import { Context } from "../..";
import Footer from "../../components/Footer/Footer";
import ManualBet from "../../components/UI/Manual_bet/ManualBet";
import ItemSlider from "../../components/UI/ItemSlider/ItemSlider.jsx"
import { observer } from "mobx-react-lite";
import SpinPage from "../../components/UI/Spin/Spin.js";
import SapperService from "../../service/SapperService.js";
import { Spin } from "antd"
import ErrorComponent from "../../components/UI/Error/ErrorComponent.js";
import formatCurrency from "../../Utils/formatCurrency.js";
import History from "./components/History/History.jsx";
import Modal from "../../components/Modals/Modal.jsx";
import HowToPlay from "../../components/Modals/components/HowToPlay/HowToPlay.jsx";
import Confetti from "react-confetti";
import Sound_play from "../../Utils/sound_play.js";
import { sound_win, sound_winGAME, succses_bet } from "../../Utils/sounds.js";
function Sapper() {
    const { store } = useContext(Context)
    const ButtonsChoiceFastSum = [5, 10, 100, 500]
    const [indexSelectedButtonsSum, setIndexSelectedButtonsSum] = useState(0)
    const [items_koef, setItems_koef] = useState(null)
    const [indexesSuccses, setIndexesSuccses] = useState([])
    const [indexsFail, setIndexsFail] = useState([])
    const [mines, setMines] = useState(2)
    const [gameState, setGameState] = useState(false);
    const [result_achive, setResult_achive] = useState(-1);
    const [loadButton, setLoadButton] = useState(false)
    const mines_map_address = [2, 3, 4, 5, 6]
    const [indexMinesAddress, setIndexMinesAddress] = useState(0)
    const [achiveKoef, setAchiveKoef] = useState(-1)
    const [loadingState, setLoadingState] = useState(true)
    const [statusReload, setStatusReload] = useState(false);
    const [modal_state, setModal_state] = useState(false)
    const [confettiRunning,setConfettiRunning] = useState(0);
    const [history_bets, setHistory_bets] = useState([])
    let [all_koefs_data, setAll_koefs_data] = useState({})
    let [cur_slice_koefs, setCur_slice_koefs] = useState([0, 6])
    const [modelInstuctionState, setModelInstuctionState] = useState(false);
    const instuction = [<>
        <div className={styles.step}>
            <span className={styles.highlight}>Ваша цель:</span> <div>открывать безопасные клетки со змейками и избегать бомб.</div>
        </div></>, <div className={styles.step}>
        <span className={styles.highlight}>Как играть:</span> Введите сумму ставки, выберите количество бомб на поле, затем нажмите кнопку «Поставить», чтобы начать игру.
    </div>, <div className={styles.step}>
        <span className={styles.highlight}>Правила:</span> Каждая клетка содержит либо змейку, либо бомбу. Открывая клетки со змейками, вы увеличиваете свой выигрышный коэффициент. Чем больше мин на поле, тем выше возможный коэффициент.
    </div>
    ]

    const [amount, setAmount] = useState(5);
    async function get_money() {
        try {
            if (!loadButton) {
                setLoadButton(true)

                const response = await SapperService.get_money()
                const dataResponse = response.data
                if (dataResponse.status === 1) {
                    if (dataResponse.balance>store.user.balance){
                        Sound_play(sound_winGAME,store.sound)

                        setConfettiRunning(1000);
                        setTimeout(()=>{
                            setConfettiRunning(0)
                        },1000)
                    }
                    store.user.balance = dataResponse.balance
                    const mines_map = Object.keys(dataResponse.mines_map)
                    const succses_map = []
                    for (let i = 0; i < 20; i++) {
                        if (!mines_map.includes(i)) {
                            succses_map.push(String(i))
                        }
                    }


                    setStatusReload(true)
                    setIndexsFail(mines_map);
                    setIndexesSuccses(succses_map)
                    setAchiveKoef(-1)

                    setResult_achive(-1);
                    setHistory_bets(dataResponse.history)

                    setItems_koef(null)



                    setLoadButton(false)
                }
            }
        }
        catch (e) {
            console.log(e)
        }
    }
    async function bet() {
        try {
            if (!loadButton) {

                if (mines >= 2) {
                    const response = await SapperService.bet(amount, mines)
                    const dataResponse = response.data;
                    if (dataResponse.err) {
                        store.add_message(dataResponse.err, ErrorComponent)
                    }
                    if (dataResponse.status === 1) {
                        Sound_play(succses_bet,store.sound)
                        setItems_koef(dataResponse.koefs_map)
                        setGameState(true)
                        setIndexsFail([]);
                        setIndexesSuccses([])
                        setAchiveKoef(-1)
                        setResult_achive(-1);


                        setLoadButton(false)
                        store.user.balance = dataResponse.balance;
                    }
                }
                else {
                    setLoadButton(false)
                }
            }
        }
        catch (e) {
            console.log(e)
        }
    }
    async function check_position(position) {
        try {
            const response = await SapperService.check_position(position);
            if (response.data.status === 1) {
                const data = response.data.data;
                if (data.status === "win") {
                    Sound_play(sound_win,store.sound)
                    setResult_achive(data.amount_now)
                    setAchiveKoef(data.koef_achive)

                    setIndexesSuccses(prev => [...prev, String(data.position)])
                }
                else {
                    setIndexsFail(prev => [...prev, String(position)]);
                    const mines_map = Object.keys(data.mines_map)
                    const succses_map = []
                    for (let i = 0; i < 20; i++) {
                        if (!mines_map.includes(i)) {
                            succses_map.push(String(i))
                        }
                    }
                    setIndexsFail(mines_map)
                    setIndexesSuccses(succses_map)
                    setHistory_bets(data.history)


                    setStatusReload(true)


                }


            }
        }
        catch (e) {
            console.log(e)
        }
    }
    async function start() {
        try {
            store.set_current_url("/sapper")
            const response = await SapperService.get_game();
            if (response.data.status === 1) {
                if (response.data.dataBet) {
                    const { opens_map, koef_achive, mines, amount, koefs_map, result, history } = response.data.dataBet;

                    setAmount(amount)
                    let index_succses_fill = Object.keys(opens_map);
                    setIndexesSuccses(index_succses_fill)
                    setAchiveKoef(koef_achive)
                    setMines(mines)
                    setItems_koef(koefs_map)
                    setGameState(true)
                    setResult_achive(result)




                }
                setAll_koefs_data(response.data.all_koefs)
                setHistory_bets(response.data.history)
                setLoadingState(false);
            }
        }
        catch (e) {
            console.log(e)
        }
    }
    useEffect(() => {
        if (gameState && statusReload) {
            setTimeout(() => {
                setIndexesSuccses([])
                setIndexsFail([])
                setItems_koef([])
                setStatusReload(false);
                setGameState(false);
            }, 2000)

        }
    }, [statusReload])
    useEffect(() => {
        start()
    }, [])
    useEffect(() => {

        if (achiveKoef > 0) {
            setCur_slice_koefs(prev => [prev[0] + 1, prev[1] + 1])
        }
        if (achiveKoef === -1) {
            setCur_slice_koefs([0, 6])
        }
    }, [achiveKoef])
    useEffect(() => {
        setMines(mines_map_address[indexMinesAddress])
    }, [indexMinesAddress])

    return (
        <>
            <Modal ModelState={modal_state} setModelState={setModal_state} Component={History} props={{ history_bets }} />
            <Modal ModelState={modelInstuctionState} setModelState={setModelInstuctionState} Component={HowToPlay} props={{ elements: instuction }} />

            <div className={`${styles.mainCotainerRoulete} fadeAnimationMain`} style={{zIndex:"100"}}>

                {loadingState ? <SpinPage /> :
                    (<>

                        <div className={styles.wrapperContentGame}>
                            <div className={styles.buttonsTools}>
                            <button onClick={() => setModelInstuctionState(true)} className={styles.howToPlay}>Как играть <i class="fa-solid fa-question"></i></button>
                                <div className={styles.blockHistoryButton} onClick={() => setModal_state(true)}>
                                    <button>История</button>
                                </div>

                            </div>
                            <div className={styles.containerTable}>

                                <ManualBet styles={styles} ButtonsChoiceFastSum={ButtonsChoiceFastSum} setAmount={setAmount} setIndexSelectedButtonsSum={setIndexSelectedButtonsSum} amount={amount} indexSelectedButtonsSum={indexSelectedButtonsSum} />
                                <div className={styles.containerMines}>
                                    <div className={styles.buttonChoiceMine} onClick={() => {
                                        if (!gameState) {
                                            if ((indexMinesAddress - 1) >= 0) {
                                                setIndexMinesAddress(indexMinesAddress - 1)
                                            }
                                        }

                                    }}>
                                        <i className="fa-solid fa-arrow-left"></i>
                                    </div>
                                    <div style={{ display: "flex" }}>
                                        <div className={styles.infoMin}>
                                            <div>{mines}</div>
                                            <div className={styles.textQtyMine}>количество бомб</div>
                                        </div>
                                    </div>

                                    <div className={styles.buttonChoiceMine} onClick={() => {
                                        if (!gameState) {
                                            if ((indexMinesAddress + 1) < mines_map_address.length) {
                                                setIndexMinesAddress(indexMinesAddress + 1)
                                            }
                                        }
                                    }}>
                                        <i className="fa-solid fa-arrow-right"></i>
                                    </div>
                                </div>
                                {(statusReload) && <button style={{ background: "#4caf50a6" }} className={`${styles.button}`}>Ожидание</button>}

                                {(gameState && result_achive === -1 && !statusReload) && <button style={{ background: "#4caf50a6" }} className={`${styles.button}`}>Вы поставили {formatCurrency(amount, "cost")}</button>}
                                {(!gameState && !statusReload) && <button onClick={async () => await bet()} className={`${styles.button} skeleton-button`} disabled={loadButton}>{loadButton ? <Spin /> : "Поставить"}</button>
                                }
                                {(gameState && result_achive > 0 && !statusReload) && <button className={styles.shiny_button} style={{ width: store.isPhone && "90%" }} disabled={loadButton} onClick={async () => await get_money()}>
                                    {loadButton ? <Spin /> : `Забрать ${formatCurrency(result_achive, "cost")}`}

                                </button>

                                }
                                <div className={styles.infoMaxWin}><i class="fa-solid fa-sack-dollar"></i><div>Макс. выигрыш {formatCurrency(amount * all_koefs_data[mines][all_koefs_data[mines].length - 1])}</div></div>

                            </div>
                            <div className={styles.containerGame}>


                                <div className={styles.cellsContainer}>
                                    {[...Array(20)].map((_, index) => {
                                        if (indexsFail.includes(String(index))) {
                                            return (
                                                <div key={index} className={styles.result} style={{ color: "red" }}>
                                                    <i className="fa-solid fa-bomb"></i>
                                                </div>
                                            );
                                        } else if (indexesSuccses.includes(String(index))) {
                                            return (
                                                <div key={index} className={styles.result}>
                                                    <i className="fa-solid fa-staff-snake"></i>
                                                </div>
                                            );
                                        } else {
                                            return (
                                                <div key={index} className={styles.cell} onClick={async () => await check_position(index)}>
                                                    {/* Здесь добавьте содержимое элемента */}
                                                </div>
                                            );
                                        }
                                    })}


                                </div>
                                {items_koef &&
                                    <div className={styles.containerKoefs}>
                                        {items_koef.slice(cur_slice_koefs[0], cur_slice_koefs[1]).map((el, index) => {
                                            const index_cur = index + cur_slice_koefs[0];

                                            return <div className={`${styles.koefBlock} ${achiveKoef > index_cur && styles.achive} ${achiveKoef === index_cur && styles.shiny_button} ${(achiveKoef + 1) === index_cur && styles.nextKoef}`} style={{ fontSize: "16px" }}>{el}x</div>


                                        }
                                        )}
                                    </div>
                                }





                            </div>
                        </div>







                    </>)
                }
                
            </div >
            <Confetti

                    width={window.innerWidth}
                    height={window.innerHeight}
                    gravity={0.5}
                    numberOfPieces={confettiRunning}
                    
                />
            <Footer />
        </>
    )
}


export default observer(Sapper);